import { useEffect, useState } from "react";
import { useLiveHours } from "@/lib/site";

export default function Schedule() {
  const hours = useLiveHours();
  return (
    <section id="schedule" className="border-y border-[#241c0d]/10 bg-[#fff1d9] py-16 sm:py-24" data-testid="schedule-section">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
        <h2 className="text-4xl leading-tight text-[#c87700] drop-shadow-[0_1px_0_rgba(122,86,0,0.6)] sm:text-6xl" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }} data-testid="schedule-heading">
          Opening Times
        </h2>

        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          <div className="card-dark p-8 sm:p-10" data-testid="schedule-weekends">
            <p className="font-display text-4xl leading-none text-[#c87700] sm:text-5xl" data-testid="schedule-weekends-hours">
              {hours.weekend_open} – {hours.weekend_close}
            </p>
            <p className="mt-4 text-lg font-extrabold text-[#241c0d] sm:text-xl">Weekends, Public- &amp; School Holidays</p>
          </div>
          <div className="card-dark p-8 sm:p-10" data-testid="schedule-weekdays">
            <p className="font-display text-4xl leading-none text-[#c87700] sm:text-5xl" data-testid="schedule-weekdays-hours">
              {hours.weekday_open} – {hours.weekday_close}
            </p>
            <p className="mt-4 text-lg font-extrabold text-[#241c0d] sm:text-xl">Monday – Friday</p>
          </div>
        </div>

        <p
          className="mx-auto mt-10 inline-flex items-center justify-center rounded-full border-2 border-[#d63a2f]/40 bg-[#d63a2f]/10 px-6 py-3 text-lg font-extrabold text-[#b91c1c] sm:text-xl"
          data-testid="schedule-rain-notice"
        >
          Closed 25 December &amp; when raining for safety
        </p>
      </div>
    </section>
  );
}
